import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    // 定义状态
    state: {
        messageTotal: 0,
        primaryDisease: [], // 一级病症
        secondaryDisease: [],// 二级病症
        gradeIIIDisease: [],// 三级病症
        gradeIVDisease: [],// 四级病症
        imgUrl:"",//存储全局图片地址头
        userInfo:{},//存储用户信息
    },
    mutations: {
      login(state, provider) {
        state.userInfo = provider;
        //缓存用户登陆状态
        sessionStorage.setItem(
          "userInfo",
          JSON.stringify(provider)
      );
      },
      primaryDisease(state, data) {
        state.primaryDisease =  data
      },
      secondaryDisease(state, data) {
        state.secondaryDisease =  data
      },
      gradeIIIDisease(state, data) {
        state.gradeIIIDisease =  data
      },
      gradeIVDisease(state, data) {
        state.gradeIVDisease =  data
      },
      //获取消息数量
      computerMessageTotal(state, data) {
          state.messageTotal = data;
          // console.log(state.messageTotal);
      },
      imgUrl(state, data) {
        state.imgUrl = data;
        // console.log(state.messageTotal);
    },
      //读取消息,计算消息数量
      readMessage(state, data) {
          if (data > 0) {
              state.messageTotal = state.messageTotal - data;
              // console.log(state.messageTotal);

          }
      }
    },
    actions: {}
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js